<template>
  <div class="ddbProtocol-wrap" :class="{ 'ddbProtocol-wrap-dark': skinModel == '1' }">
    <p
      class="open-sentence"
    >   【审慎阅读】欢迎您使用铛铛币充值服务！在同意本协议前，请您认真阅读并充分知悉、理解铛铛平台的各项规则及要求，以及国家关于该类互联网信息服务的法律法规等。如果您对本协议的任何条款表示异议，您可以选择不使用；使用则意味着您将同意遵守本协议项下全部规定，以及我们后续对充值服务所作的任何修改。本协议已对与您的权益具有或可能具有重大关系的条款，及对铛铛平台具有或可能具有免除或限制责任的条款用粗体字予以标注，请您注意。</p>
    <p class="open-sentence">   【特别提示】 充值用户须确认自己具有完全民事行为能力，已年满18周岁，或已年满16周岁且依靠自己的劳动收入作为主要生活来源。未成年用户使用铛铛币充值服务，必须得到家长或其他合法监护人的同意。铛铛对于未成年人用户使用本服务过程中的行为，以及因其使用本服务而产生的一切后果不承担责任。
      <br />铛铛公司谨此提醒家长合理引导未成年子女的上网及消费行为。
    </p>

    <div class="recharge-item">
      <p class="recharge-item-title">1.服务说明</p>
      <p>1.1 铛铛币是铛铛为用户提供的用于在铛铛平台进行相关消费的虚拟货币，您可以用“铛铛币”自由兑换成各项产品或服务。铛铛币只能兑换为铛铛零钱，不能直接兑换人民币，请您根据自己的实际需求购买相应数量的铛铛币。</p>
      <p>1.2 铛铛币属于在线交付的充值类商品，因其特殊属性不适用《消费者权益保护法》中有关反悔权及网络购买商品七日无理由退货等条款的约束，用户一旦充值成功，充值即确定完成，铛铛不提供任何退还或逆向兑换服务。因铛铛币无法使用而产生异议，用户可以通过客服专线查询处理。</p>
      <p>1.3 铛铛的充值系统提供支付宝、微信等不同的充值方式。用户使用该平台进行充值，可以为铛铛账号充值铛铛币的数量。</p>
      <p>1.4 用户使用上述充值方式进行充值后，应保留充值订单号或充值卡以作为今后发生问题核对依据凭证，用户就充值服务投诉，但未提供任何有效凭证的，铛铛将不会作出任何补偿和赔偿。</p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">2.使用规则</p>
      <p>2.1 用户必须为绑定的支付账户开户人/持有人，可合法、有效使用该账户且未侵犯任何第三方权益，否则因此造成支付账户实际所有人损失的，应由用户单独负责解决由此产生的纠纷并承担全部法律责任。</p>
      <p>2.2 用户必须采用铛铛所指定的充值方式增加账户所有的铛铛币数量。若使用非铛铛所指定的充值系统进行充值，或以非法的方式进行充值而造成用户权益受损时，不得因此要求铛铛作任何补偿或赔偿，铛铛也保留随时终止该账户资格及使用各项充值服务的权利。</p>
      <p>2.3 在使用铛铛币充值系统时，用户务必仔细确认自己的账号及充值金额，因用户自身原因输入账号错误、操作不当或不了解充值计费方式等因素造成充错账号、选错充值种类、填错充值金额等情形而损害自身权益的，应自行承担责任。</p>
      <p>2.4 若因用户违反铛铛用户协议或本充值服务协议，铛铛因此冻结账号及终止账号使用资格者，不得要求铛铛作任何补偿或赔偿。</p>
      <p>2.5 如果铛铛平台发现因系统故障或其他任何原因导致的处理错误，无论有利于铛铛平台还是有利于您，铛铛平台都有权在以电子邮件、电话、私信或其他合理方式通知您后纠正该错误。如果该措施导致您实际收到的铛铛币数量少于您应获得的铛铛币，则铛铛平台在确认该处理错误后会尽快将差额补足至您的账户中。如果该错误导致您实际收到的铛铛币数量多余您应获得的铛铛币，则无论错误的性质和原因如何，铛铛平台有权从您的账户中直接扣除差额。</p>
      <p>2.6 用户不得通过铛铛币充值进行任何违法犯罪活动，否则铛铛有权终止服务，情节严重的，依法移交司法机关。</p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">3.渠道商服务手续费用</p>
      <p>各充值方式对应的渠道商可能会按其标准制定相关充值渠道手续费用（可能会在充值操作页面或渠道商其他页面上提示），并在用户充值时收取。铛铛特此提醒：请用户务必注意各充值方式的渠道商服务手续费，并按自己的需求选取充值方式。</p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">4.免责声明</p>
      <p>4.1 您可随时在网页端或手机APP上查看您的账户铛铛币余额。如您对该记录有异议，应立即向铛铛平台提出，铛铛平台核对后确有错误的，将予以改正；否则您同意铛铛平台上的交易记录作为铛铛币交易的唯一有效依据。</p>
      <p>4.2 铛铛平台有权基于交易安全等方面的考虑不时设定涉及交易的相关事项，包括但不限于交易限额，交易次数等。您了解，铛铛平台的前述设定可能对您的充值交易造成一定不便，您对此没有异议。</p>
      <p>4.3 在任何情况下，对于您购买铛铛币时涉及由第三方提供相关服务的责任由该第三方承担，铛铛平台不承担该等责任。</p>
      <p>4.4 因您自身的原因导致铛铛平台无法提供铛铛币购买服务或提供铛铛币购买服务时发生任何错误而产生的任何损失或责任，由您自行负责，铛铛平台不承担责任，包括但不限于：（1）您未按照本协议或铛铛平台不时公布的任何规则进行操作；（2）因您的铛铛账号失效、丢失、被封停；（3）因您绑定的第三方支付机构账户的原因导致的损失或责任，包括您使用未经认证的第三方支付账户或使用非您本人的第三方支付账户，您的第三方支付账户被冻结、查封等；（4）您将密码告知他人导致的财产损失；（5）因您个人的故意或重大过失所造成的财产损失。</p>
      <p>4.5 铛铛平台系统因下列状况无法正常运作，使您无法使用各项服务或任何虚拟财产丢失时，本团队不承担损害赔偿责任，该状况包括但不限于：（1）在铛铛平台公告之系统停机维护、升级、调整期间；（2）电信通讯或设备出现故障不能进行数据传输的；（3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制等不可抗力之因素，造成铛铛平台系统障碍不能执行业务的；（4）由于黑客攻击、电信部门技术调整或故障、网站升级、相关第三方的问题等原因而造成的服务中断或者延迟。</p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">5.服务变更、中断或终止</p>
      <p>5.1 铛铛平台可以根据业务需求随时变更服务或更新本协议的条款，但应在相关的页面上及时提示修改内容。修改后的服务协议一旦在页面公布即替代原来的服务协议。您可随时通过铛铛币充值页面查阅最新的充值服务协议。</p>
      <p>5.2 如发生下列任何一种情况，铛铛平台有权随时中断或终止向您提供本协议项下的网络服务而无需通知您：（1）您提供的个人资料不真实；（2）您违反本协议规定的购买规则；（3）您违反铛铛用户协议及其铛铛直播平台管理规则。除前款所述情形外，铛铛平台同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络充值服务的权利，对于充值服务的中断或终止而造成的任何损失，铛铛平台无需对用户或任何第三方承担任何责任。</p>
      <p>5.3 如果用户违规使用非本人苹果手机应用商店代充值，或者通过其他未经铛铛平台认可的渠道非法购买铛铛币，则铛铛平台有权冻结该账户，并进行相应处罚，严重违规者将封号处理。</p>
      <p>5.4 用户在使用铛铛平台时，如出现违反国家法律法规、《用户注册协议》、《铛铛直播平台违规管理办法》、本协议规定或其他铛铛平台对用户的管理规定之情形，铛铛平台有权暂时或永久封禁您的账号。账号封禁后至解禁前（如有），您账户上的剩余铛铛币将被暂时冻结或全部扣除，不可继续用于购买平台上的虚拟产品或服务，同时不予返还您购买铛铛币时的现金价值。</p>
    </div>

    <div class="recharge-item">
      <p class="recharge-item-title">6.法律适用、管辖及其他</p>
      <p>6.1 本协议签订地为中华人民共和国北京市朝阳区。</p>
      <p>6.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。</p>
      <p>6.3 若您和铛铛之间因本协议发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交至铛铛所在地有管辖权的人民法院管辖。</p>
      <p>6.4 本协议任意一条被视为废止、无效或不可执行，该条款视为可分的且不影响本协议其余条款的有效性及执行性。</p>
    </div>
    <!-- <p class="sign">铛铛</p> -->
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      skinModel: "0",
    };
  },
  beforeRouteEnter(to, from, next) {
    let skinModel = to.query.skinModel;
    next((vm) => {
      vm.skinModel = skinModel;
    });
  },
};
</script>

<style lang="less">
.ddbProtocol-wrap {
  padding: 0 19px 83px;
  line-height: 26px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #1a1a1a;
  .open-sentence {
    margin-top: 26px;
  }
  .recharge-item {
    margin-top: 52px;

    p {
      margin-top: 26px;

      &.recharge-item-title {
        color: #1A1A1A;
        font-weight: 700;
      }
    }
  }

  .sign {
    padding-right: 15px;
    margin-top: 35px;
    text-align: right;
  }
}

.ddbProtocol-wrap-dark {
  color: #d1d1d1;
  .recharge-item {
    p {
      &.recharge-item-title {
        color: #d1d1d1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/ddbProtocol/ddbProtocolAndroid.vue